import { registerMicroApps, initGlobalState, start, MicroAppStateActions } from 'qiankun'

const initialState = {}
const actions = initGlobalState(initialState)
// actions.onGlobalStateChange((state, prevState) => {
//   console.log("主應用觀察者：token 改變前的值為 ", prevState.token);
//   console.log(
//     "主應用觀察者：登入狀態發生改變，改變後的 token 的值為 ",
//     state.token
//   );
// });

const micrApp = {
  init: () => {
    registerMicroApps(
      [
        {
          name: 'design', //這裡的name一定要和微應用這配置的output中的library相互對應，因為name是主應用找到微應用對外暴露的生命週期函式的主要憑證
          entry: process.env.VUE_APP_QIANKUN_ENTRY, //這是微應用的入口地址
          // entry: `http://localhost:8081/newpc/`,
          container: '#design-view', //這是在主應用中微應用的渲染承載容器
          activeRule: '/wxapp/pcmall/design' //這是進行路由監聽，一旦匹配，就會載入微應用並進行掛載，這裡也要主要在微應用中需要設定路由base的時候要相互對應，後面會提到
          //   props: {
          //     sysConfig: {
          //       mode: "pc",
          //       token: store.getters.token,
          //       pageid: id,
          //     },
          //   },
        }
      ],
      {
        beforeLoad: [
          (app) => {
            console.log('before load', app)
          }
        ], // 掛載前回撥
        beforeMount: [
          (app) => {
            console.log('before mount', app)
          }
        ], // 掛載後回撥
        afterUnmount: [
          (app) => {
            console.log('after unload', app)
          }
        ] // 解除安裝後回撥
      }
    )
    start()
  }
}

export { micrApp, actions }
